import script from "./OAuthButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./OAuthButtons.vue?vue&type=script&setup=true&lang=js"

import "@/components/auth/OAuthButtons.css?vue&type=style&index=0&id=262760d2&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-262760d2"]])

export default __exports__